import { observer } from 'mobx-react';
import { Component } from 'react';

import { ConfiguratorPageTranslation, RequestQuoteLinkTranslation } from '../../localization/SiteTranslation';
import RequestQuoteLink from '../../requestQuote/RequestQuoteLinkButton/RequestQuoteLink';
import ActionButton from '../../shared/components/ActionButton';
import TextButton from '../../shared/components/Button/TextButton';
import { StoreState } from '../../StoreState';
import { ConfiguratorState } from '../ConfiguratorState';
import css from './ConfigurationSummary/ConfigurationSummary.css';

export interface ConfiguratorActionsState {
  configurator: ConfiguratorState;
  store: StoreState;
  translation: ConfiguratorPageTranslation;
  requestQuoteLinkTranslation: RequestQuoteLinkTranslation;
}

export interface ConfiguratorActionsProps {
  state: ConfiguratorActionsState;
}

@observer
export default class ConfiguratorActions extends Component<ConfiguratorActionsProps> {
  static checkoutButtonId = 'checkout-button';

  render() {
    const { configurator, store, requestQuoteLinkTranslation, translation } = this.props.state;
    const { configurationCodeLoading } = configurator.coreState;

    const canBePurchased = store.canBePurchased(configurator.baseModel);
    const canRequestQuote = store.canRequestQuote();
    const quantityExceeded =
      !isNaN(configurator.quantityInput.value) && configurator.quantityInput.value > configurator.quantityMax;
    const showCheckoutButton = canBePurchased && !quantityExceeded;

    const checkoutButton = (
      <ActionButton
        command={configurator.proceedToCheckoutCommand}
        className={css.checkoutButton}
        disabled={configurationCodeLoading}
      >
        {translation.summary.checkoutButton}
      </ActionButton>
    );

    const limitedQuantityMessage = (
      <div className={css.limitedQuantityContainer}>
        {translation.summary.limitedChairQuantity.interpolate([['max', configurator.quantityMax.toString()]])}
      </div>
    );

    const requestQuoteButton = (
      <div className={css.requestQuoteButtonContainer}>
        <ActionButton
          className={css.requestQuoteButton}
          command={configurator.requestQuoteState.proceedToRequestQuoteCommand}
          disabled={configurationCodeLoading}
        >
          {translation.summary.requestQuoteButton}
        </ActionButton>
        {canBePurchased && quantityExceeded && limitedQuantityMessage}
      </div>
    );

    const requestQuoteLink = (
      <RequestQuoteLink
        translation={requestQuoteLinkTranslation}
        className={css.requestQuoteLink}
        configurationCode={this.props.state.configurator.coreState.code}
        disabled={configurationCodeLoading}
      />
    );

    return (
      <div className={css.actionButtonsContainer}>
        <div className={css.actionButtons} id={ConfiguratorActions.checkoutButtonId}>
          {showCheckoutButton && checkoutButton}
          {!showCheckoutButton && canRequestQuote && requestQuoteButton}
        </div>
        {canBePurchased && canRequestQuote && requestQuoteLink}
        <TextButton
          className={css.configurationShareButton}
          onClick={() => configurator.configurationShareModal.open()}
        >
          {translation.summary.saveYourConfigurationHereButton}
        </TextButton>
      </div>
    );
  }
}
